import { render } from "./Separator.vue?vue&type=template&id=3b7e8d70&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"

import "./Separator.vue?vue&type=style&index=0&id=3b7e8d70&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b7e8d70"

export default script